import { DEFAULT_TEMPLATE_TASK_DUE_DATE_OFFSET, TEMPLATE_ASSIGNEE_RULE } from './template.config.js'

import i18n from '@/i18n'

/** Client-only tokens for open vs completed sub-tasks (`completedAt` null vs set). */
export const TASK_STATUS = Object.freeze({
  OPEN: 'open',
  COMPLETED: 'completed',
})

/** Dropdown options for the task open / completed toggle. */
export const TASK_STATUS_OPTIONS = Object.freeze([
  {
    value: TASK_STATUS.OPEN,
    label: i18n.global.t('tickets.management.taskKanban.notCompleted'),
  },
  {
    value: TASK_STATUS.COMPLETED,
    label: i18n.global.t('tickets.management.taskKanban.completed'),
  },
])

/** Default shape for a ticket-editor sub-task row (matches server-spec). */
export const TICKET_TASK_SHAPE = Object.freeze({
  title: '',
  description: '',
  assignees: [],
  dueDate: null,
  completedAt: null,
  priority: null,
})

/** Default shape for a template-settings sub-task row. */
export const TEMPLATE_TASK_SHAPE = Object.freeze({
  title: '',
  description: '',
  assigneeRule: TEMPLATE_ASSIGNEE_RULE.TRIGGER_ASSIGNEE,
  assignees: [],
  priority: '',
  dueDateOffset: DEFAULT_TEMPLATE_TASK_DUE_DATE_OFFSET,
})
